import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { newsletterSubscribe } from '../../ducks/newsletter.duck';
import NewsletterForm from '../../forms/NewsletterForm/NewsletterForm';

const listItemStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: '6px',
};

const listItemIconStyle = {
  color: 'var(--successColor)',
  marginRight: '4px',
};

/**
 * SectionNewsletter component for the LandingPage.
 * @param {object} props
 * @param {string} props.googleCaptchaElementId captcha element id
 * @param {function} [props.onClose] when it is used in a modal, this function will be called when the modal is closed
 * @param {'row'|'coulmn' } props.direction  direction of the form
 * @returns {React.ReactNode}
 * @constructor
 */

const SectionNewsletterComponent = ({
  googleCaptchaElementId,
  onClose = () => null,
  direction = 'row',
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    onClose();
    return dispatch(newsletterSubscribe(values));
  };

  return (
    <Stack spacing={2} width="100%">
      <Box>
        <Chip label={intl.formatMessage({ id: 'SectionNewsletter.voucher' })} />
      </Box>
      <Box>
        <Grid container spacing={4}>
          <Grid size={{ md: direction === 'row' ? 7 : 12, xs: 12 }}>
            <Stack spacing={2}>
              <Typography component="h2" variant="h4">
                <FormattedMessage id="SectionNewsletter.title" />
              </Typography>
              <List sx={{ pl: 1.5 }}>
                <ListItem sx={{ display: 'flex', alignItems: 'center', mb: 0.75 }}>
                  <ListItemIcon sx={{ color: 'success.main', minWidth: 32 }}>
                    <CheckBoxIcon />
                  </ListItemIcon>
                  <ListItemText>
                    <FormattedMessage id="SectionNewsletter.li.1" />
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ display: 'flex', alignItems: 'center', mb: 0.75 }}>
                  <ListItemIcon sx={{ color: 'success.main', minWidth: 32 }}>
                    <CheckBoxIcon />
                  </ListItemIcon>
                  <ListItemText>
                    <FormattedMessage id="SectionNewsletter.li.2" />
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ display: 'flex', alignItems: 'center', mb: 0.75 }}>
                  <ListItemIcon sx={{ color: 'success.main', minWidth: 32 }}>
                    <CheckBoxIcon />
                  </ListItemIcon>
                  <ListItemText>
                    <FormattedMessage id="SectionNewsletter.li.3" />
                  </ListItemText>
                </ListItem>
              </List>
            </Stack>
          </Grid>
          <Grid size={{ md: direction === 'row' ? 5 : 12, xs: 12 }} sx={{ marginTop: { xs: 2, md: 0 } }}>
            <NewsletterForm elementId={googleCaptchaElementId} onSubmit={handleSubmit} />
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
};

SectionNewsletterComponent.displayName = 'SectionNewsletter';

const SectionNewsletter = memo(SectionNewsletterComponent);

export default SectionNewsletter;
